export default __webpack_public_path__ + "d4ca7e45cfa78b1ffa208eca76f718ab.jpg";